/**
 * Derive per-screen intake skip flags from returning-patient data.
 *
 * Only set when the patient explicitly confirmed their info on the
 * returning patient happy path (`infoConfirmed: true`). If `rpo` is
 * undefined or `infoConfirmed` is false, all flags return `undefined`
 * so the intake arc falls through to the full flow.
 */

import type { ReturningPatientOutput } from "../contracts/arc-contracts";

export type IntakeSkipFlags = {
  hasPharmacy: boolean | undefined;
  hasPCP: boolean | undefined;
  hasEmergencyContact: boolean | undefined;
};

export function deriveIntakeSkipFlags(
  rpo: ReturningPatientOutput | undefined,
): IntakeSkipFlags {
  if (!rpo?.infoConfirmed) {
    return {
      hasPharmacy: undefined,
      hasPCP: undefined,
      hasEmergencyContact: undefined,
    };
  }

  return {
    hasPharmacy: !!rpo.pharmacyName,
    hasPCP: !!rpo.pcpFirstName,
    hasEmergencyContact: !!rpo.emergencyContactFirstName,
  };
}
